import { render, staticRenderFns } from "./MessageBuilder.vue?vue&type=template&id=a5a95f5c&scoped=true"
import script from "./MessageBuilder.vue?vue&type=script&lang=js"
export * from "./MessageBuilder.vue?vue&type=script&lang=js"
import style0 from "./MessageBuilder.vue?vue&type=style&index=0&id=a5a95f5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5a95f5c",
  null
  
)

export default component.exports